import { AxiosResponse } from 'axios';
import { AuditMessage } from './AuditMessage';
import VersionedResource from '../VersionedResource';

export default class AuditMessageResource extends VersionedResource {
  public async getAll(fiId: number) : Promise<AuditMessage[]> {
    const url = `/api/rcx/config/${fiId}/audit`;
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if processing days has not been set up yet, so return empty Audit Message
      if (error.response.status !== 404) {
        throw error;
      } else {
        return AuditMessageResource.createEmptyAuditMessage();
      }
    }
  }

  public static createEmptyAuditMessage() : AuditMessage[] {
    return [{
      id: undefined!,
      time: '',
      userName: '',
      api: '',
      method: '',
      message: '',
      fiId: '',
      contentBefore: '',
      contentAfter: '',
    }];
  }
}
